import React, { useCallback, useState } from 'react';
import { usePopper } from 'react-popper';
import usePortal from 'react-useportal';
import { useIsBusy } from '../../../data/hooks/ui/useIsBusy';
import { useIsDemoMode } from '../../../data/hooks/ui/useIsDemoMode';
import { useGlobalMotionUpdate } from '../../../misc/useGlobalMotionUpdate';
import Icon from '../icons/Icon';
import stylesheet from './Tooltip.module.scss';

const Tooltip = (props) => {
    const { className = '', onClose, children } = props,
        [referenceElement, setReferenceElement] = useState(null),
        [popperElement, setPopperElement] = useState(null),
        [arrowElement, setArrowElement] = useState(null),
        { styles, attributes, update, forceUpdate } = usePopper(referenceElement, popperElement, {
            placement: 'bottom-start',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [-64, 5],
                    },
                },
            ],
        }),
        { Portal } = usePortal(),
        isBusy = useIsBusy(),
        isDemo = useIsDemoMode();

    const handleClose = useCallback(
        (e) => {
            e.stopPropagation();
            e.preventDefault();

            if (onClose) onClose();
        },
        [onClose]
    );

    useGlobalMotionUpdate(update);

    if (isBusy) return null;
    if (isDemo) return null;

    return (
        <>
            <span ref={setReferenceElement} className={stylesheet.reference} />
            <Portal>
                <div ref={setPopperElement} className={[stylesheet.Tooltip, className].join(' ')} style={styles.popper} {...attributes.popper}>
                    <div ref={setArrowElement} className={stylesheet.arrow} />
                    {onClose ? (
                        <button type="button" className={stylesheet.close} onClick={handleClose}>
                            <Icon src="/img/reject_icon.png" color="#a9a9a9" />
                        </button>
                    ) : null}
                    {children}
                </div>
            </Portal>
        </>
    );
};

export default Tooltip;
